// Polyfills for Browser Support (IE)
import 'core-js/shim';
import 'raf/polyfill';

import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';

import './money.css';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import reducer from './Store/reducer';

import ReactGA from 'react-ga';
ReactGA.initialize('UA-85602303-33');
ReactGA.pageview(window.location.pathname + window.location.search);

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(reducer, composeEnhancers(
	applyMiddleware(thunk)
));

const app = (
	<Provider store={store}>
		<BrowserRouter basename="/xpedite">
			<App />
		</BrowserRouter>
	</Provider>
);

ReactDOM.render(app, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js